import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'

import { GetTheme } from "./Themes"
import { Translate } from "./Translator"
import { SigninApiSetUserSetting } from "../ExternalApi/SigninApi"

import IntegrationPngLight from '../Assets/integration_lightbg.png'
import IntegrationPngDark from '../Assets/integration_darkbg.png'
import DownPngDark from '../Assets/down_darkbg.png'
import DownPngLight from '../Assets/down_lightbg.png'
import UpPngDark from '../Assets/up_darkbg.png'
import UpPngLight from '../Assets/up_lightbg.png'

//Embedded
import { IsEmptyString } from "./GeneralFunctions";

const UserSettingsIntegrations = (props) => {
    
    const [mIntegrations, SetIntegrations] = useState([])
    const [mChangeOrder, SetChangeOrder] = useState(true)

    useEffect(() => {    
        const IntegrationOrderString = localStorage.getItem("integrationorder")
        const IntegrationOrder = IsEmptyString(IntegrationOrderString) ? [] : IntegrationOrderString.split(",")
        SetIntegrations(props.Integrations.filter(integration => (integration.ReplicatorId !== "DefaultScripts")).sort((a, b) => {
            const indexA = IntegrationOrder.indexOf(a.ReplicatorId);
            const indexB = IntegrationOrder.indexOf(b.ReplicatorId);

            if (indexA === -1 && indexB === -1) return 0;  // Both not in secondArray, keep order
            if (indexA === -1) return 1;  // Move items not in secondArray to the end
            if (indexB === -1) return -1; // Move items in secondArray to the front

            return indexA - indexB;  // Sort based on position in secondArray
        }))      
    }, []); 

    const IntegrationOrderDown = (replicatorid) => {
        let Integrations = [...mIntegrations]
        const index = mIntegrations.findIndex(item => item.ReplicatorId === replicatorid);
        if (index < Integrations.length - 1) {
            [Integrations[index], Integrations[index + 1]] = [Integrations[index + 1], Integrations[index]];
        }
        SetIntegrations([...Integrations]);
        
        let IntegrationOrder = []
        mIntegrations.map((integration) => IntegrationOrder.push(integration.ReplicatorId))
        localStorage.setItem("integrationorder",IntegrationOrder.join(","))
        SigninApiSetUserSetting(props.SecurityToken,"IntegrationOrder",IntegrationOrder.join(",")) 
    }

    const IntegrationOrderUp = (replicatorid) => {
        let Integrations = [...mIntegrations]
        const index = mIntegrations.findIndex(item => item.ReplicatorId === replicatorid);
        if (index > 0) {
            [Integrations[index], Integrations[index - 1]] = [Integrations[index - 1], Integrations[index]];
        }
        SetIntegrations([...Integrations]);
        
        let IntegrationOrder = []
        Integrations.map((integration) => IntegrationOrder.push(integration.ReplicatorId))
        localStorage.setItem("integrationorder",IntegrationOrder.join(","))
        SigninApiSetUserSetting(props.SecurityToken,"IntegrationOrder",IntegrationOrder.join(",")) 
    }
   
    return <>
        <table>
            <tbody>                
                {mIntegrations.map(
                    (integration,index) => <tr key={index}>
                        <td width="16">{(index+1)}.</td>
                        <td><img src={GetTheme() === "dark" ? IntegrationPngDark : IntegrationPngLight} className="foregroundasbackground" width="24"/> {integration.ApplicationName}</td> 
                        {mChangeOrder ? <>
                            <td width="20"/>
                            <td>
                                <img disabled src={GetTheme() === "dark" ? UpPngDark : UpPngLight} style={{ cursor: "pointer", opacity: (index === 0 ? "0.2" : "1") }} onClick={() => IntegrationOrderUp(integration.ReplicatorId)}/> 
                            </td>
                            <td width="2"/>
                            <td> 
                                <img src={GetTheme() === "dark" ? DownPngDark : DownPngLight} style={{ cursor: "pointer", opacity: (index < mIntegrations.length - 1 ? "1" : "0.2") }} onClick={() => IntegrationOrderDown(integration.ReplicatorId)}/>
                            </td></> : <></>}
                    </tr>
                )}
            </tbody>
        </table>
    </>

}
    
UserSettingsIntegrations.propTypes = {
    SecurityToken: PropTypes.string,
    Integrations: PropTypes.array
}

export default UserSettingsIntegrations